(function () {
  var STORAGE_KEY = 'dd_meta_attribution_v1';
  var CART_UPDATE_SIGNATURE_KEY = 'dd_meta_cart_update_signature_v1';

  function normalizeValue(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function readCookie(name) {
    var cookieParts = document.cookie ? document.cookie.split(';') : [];

    for (var i = 0; i < cookieParts.length; i += 1) {
      var part = cookieParts[i].trim();
      var prefix = name + '=';

      if (part.indexOf(prefix) === 0) {
        try {
          return normalizeValue(decodeURIComponent(part.slice(prefix.length)));
        } catch (error) {
          return normalizeValue(part.slice(prefix.length));
        }
      }
    }

    return '';
  }

  function readUrlParam(name) {
    try {
      return normalizeValue(new URLSearchParams(window.location.search).get(name) || '');
    } catch (error) {
      return '';
    }
  }

  function readStoredAttribution() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : {};

      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function writeStoredAttribution(data) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function readLastCartUpdateSignature() {
    try {
      return window.sessionStorage.getItem(CART_UPDATE_SIGNATURE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function writeLastCartUpdateSignature(signature) {
    try {
      window.sessionStorage.setItem(CART_UPDATE_SIGNATURE_KEY, signature);
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function collectAttribution() {
    var stored = readStoredAttribution();

    var fbclid = readUrlParam('fbclid') || normalizeValue(stored.fbclid);
    var fbp = readCookie('_fbp') || normalizeValue(stored._fbp);
    var fbc = readCookie('_fbc') || normalizeValue(stored._fbc);

    if (!fbc && fbclid) {
      fbc = 'fb.1.' + Date.now() + '.' + fbclid;
    }

    var data = {};

    if (fbp) data._fbp = fbp;
    if (fbc) data._fbc = fbc;
    if (fbclid) data.fbclid = fbclid;

    if (Object.keys(data).length) {
      writeStoredAttribution(data);
    }

    return data;
  }

  function getStorefrontAttributes() {
    var data = collectAttribution();

    return Object.keys(data).map(function (key) {
      return {
        key: key,
        value: data[key]
      };
    });
  }

  function shouldSkipAjaxCartUpdate() {
    return document.body && document.body.classList.contains('dd-loading-page');
  }

  function persistAjaxCartAttributes() {
    var data = collectAttribution();
    var keys = Object.keys(data);

    if (!keys.length || shouldSkipAjaxCartUpdate()) return;

    var signature = JSON.stringify(data);

    if (signature === readLastCartUpdateSignature()) return;

    fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      keepalive: true,
      body: JSON.stringify({
        attributes: data
      })
    })
      .then(function (response) {
        if (response.ok) {
          writeLastCartUpdateSignature(signature);
        }
      })
      .catch(function () {
        // Do not block shopping or checkout if attribution persistence fails.
      });
  }

  window.DealDunkMetaAttribution = {
    collect: collectAttribution,
    getStorefrontAttributes: getStorefrontAttributes,
    persistAjaxCartAttributes: persistAjaxCartAttributes
  };

  function schedulePersistence() {
    persistAjaxCartAttributes();
    window.setTimeout(persistAjaxCartAttributes, 1500);
    window.setTimeout(persistAjaxCartAttributes, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePersistence);
  } else {
    schedulePersistence();
  }

  window.addEventListener('pageshow', schedulePersistence);
})();
